// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2176":"7e2063531885315a","2888":"c58adfa6acdb6be4"}[chunkId] + ".css";
};